import { error as orderFormError } from '#components/order/CreateOrderDialog/OrderFormValidation.ts';
import type { Stop } from '#domain/Stop.ts';

import { mapStopTypeToStop, type TourStop } from './TourStop.ts';

export type EditedStopOrderValidationError = {
    field: 'startDate';
    message: string;
};

export const validateEditedStopOrder = (
    updatedStop: Stop,
    stopToEdit: TourStop | undefined,
    sortableTourStops: TourStop[]
): EditedStopOrderValidationError | undefined => {
    if (!stopToEdit) {
        return undefined;
    }

    const pairedStop = sortableTourStops.find(
        stop => stop.orderId === stopToEdit.orderId && stop.type !== stopToEdit.type
    );

    if (!pairedStop) {
        return undefined;
    }

    const loadingStop = updatedStop.type === 'load' ? updatedStop : mapStopTypeToStop(pairedStop);
    const unloadingStop = updatedStop.type === 'unload' ? updatedStop : mapStopTypeToStop(pairedStop);

    if (new Date(unloadingStop.startTarget) < new Date(loadingStop.startTarget)) {
        return { field: 'startDate', message: orderFormError.DATE_ORDER };
    }

    return undefined;
};
